import { Component, ViewEncapsulation, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { GlobalStateService } from 'src/app/services/global/global-state.service';
import { AuthService } from 'src/app/services/auth/auth.service';
import { Router } from '@angular/router';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-user-menu',
  templateUrl: './user-menu.component.html',
  styleUrls: ['./user-menu.component.scss'],
  encapsulation: ViewEncapsulation.None,

})
export class UserMenuComponent implements OnInit, OnDestroy {
  user: any = null;
  isLoggedIn: boolean = false;
  private subscriptions: Subscription[] = [];

  constructor(
    private _globalStateService: GlobalStateService,
    private _authService: AuthService,
    private router: Router
  ) {}

  ngOnInit() {
    // Subscribe to user changes
    this.subscriptions.push(
      this._globalStateService.user.subscribe(user => {
        this.user = user;
        console.log('User updated in UserMenuComponent:', user);
      })
    );

    // Subscribe to login state changes
    this.subscriptions.push(
      this._globalStateService.isLoggedIn.subscribe(isLoggedIn => {
        this.isLoggedIn = isLoggedIn;
      })
    );
  }

  ngOnDestroy() {
    // Clean up subscriptions
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }

  // Get user display name
  getUserDisplayName(): string {
    if (!this.user) return 'Guest';
    return this.user.name || this.user.first_name || this.user.username || 'User';
  }

  // Get user email
  getUserEmail(): string {
    if (!this.user) return '';
    return this.user.email || '';
  }

  // Get user role or title
  getUserRole(): string {
    if (!this.user) return '';

    switch(this.user.role){
      case 10:
        return 'Administrator';
      default:
        return 'User';
    }
  }

  // Get user avatar URL
  getUserAvatar(): string {
    if (!this.user || !this.user.avatar) {
      return '/assets/media/avatars/300-3.jpg'; // Default avatar
    }
    return this.user.avatar;
  }

  // Handle logout with confirmation
  logout() {
    Swal.fire({
      title: 'Sign Out',
      text: 'Are you sure you want to sign out?',
      icon: 'warning',
      showCancelButton: true,
      buttonsStyling: false,
      confirmButtonText: 'Yes, sign out!',
      cancelButtonText: 'Cancel',
      customClass: {
        confirmButton: 'btn fw-bold btn-danger',
        cancelButton: 'btn fw-bold btn-active-light-primary'
      }
    }).then((result) => {
      if (result.isConfirmed) {
        // User confirmed logout
        this._authService.Logout();

      }
    });
  }
}
